export const POSITIONS = ['left', 'top', 'right', 'bottom'] as const;



// WEBPACK FOOTER //
// ../src/constants.ts